import { Box } from '@material-ui/core'
import * as Sentry from '@sentry/react'
import { ElementWithChildren } from 'types'
import { useUser } from './UserProvider'

export const AppRerenderer = ({ children }: ElementWithChildren): JSX.Element => {
  const { activeGame, user } = useUser()

  Sentry.setUser({
    id: user._id,
    cardmarketUsername: user.cardmarketUsername,
  })

  return <Box key={activeGame.name + user.cardmarketUsername}>{children}</Box>
}
